import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../utils';

interface ThemeToggleProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'button' | 'icon';
  showLabel?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
  className, 
  size = 'md', 
  variant = 'button',
  showLabel = true 
}) => {
  const { theme, toggleTheme } = useTheme();

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  const buttonSizes = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-2 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSize = iconSizes[size];
  const buttonSize = buttonSizes[size];

  if (variant === 'icon') {
    return (
      <button
        onClick={toggleTheme}
        className={cn(
          'p-2 rounded-lg theme-transition theme-bg-hover theme-text-secondary',
          className
        )}
        title={theme === 'light' ? '切换到深色模式' : '切换到浅色模式'}
      >
        {theme === 'light' ? (
          <Moon className={iconSize} />
        ) : (
          <Sun className={iconSize} />
        )}
      </button>
    );
  }

  return (
    <button
      onClick={toggleTheme}
      className={cn(
        'flex items-center space-x-2 rounded-lg theme-button theme-transition theme-border-focus',
        buttonSize,
        className
      )}
      title={theme === 'light' ? '切换到深色模式' : '切换到浅色模式'}
    >
      {theme === 'light' ? (
        <Moon className={iconSize} />
      ) : (
        <Sun className={iconSize} />
      )}
      {showLabel && (
        <span>
          {theme === 'light' ? '深色模式' : '浅色模式'}
        </span>
      )}
    </button>
  );
};

export default ThemeToggle; 